/*
 * @Author: Wang Bingjing
 * @Date: 2021-03-01 17:34:26
 * @LastEditTime: 2021-03-02 16:29:55
 * @LastEditors: Wang Bingjing
 */
import React, { createContext, useReducer } from 'react';

export const Usercontext = createContext({})

export const LOAD_USER = 'LOAD_USER';

const initState = {
    userList: []
}


const reducer = (state = initState, action) => {
    switch (action.type) {
        case LOAD_USER:
            const newState = { ...state }
            newState.userList = action.payload
            return newState
        default:
            return state
    }
}

export const UserProvider = props => {
    const [userInfo, dispatch] = useReducer(reducer, [])
    return (
        <Usercontext.Provider value={{ userInfo, dispatch }}>
            {props.children}
        </Usercontext.Provider>
    )
}

